export interface IPixelAddToCartDataModel
{
  value: number;
  currency: string;
  content_name: string;
  content_type: string;
  contents: IPixelContentsDataModel[];
}

export interface IPixelContentsDataModel
{
  id: string;
  quantity: number;
  item_price?: number;
  location?: string; // Propiedad custom: ubicación específica de donde se agregó al carrito dicho producto
  type?: string; // Propiedad custom: tipo de adquisición (adquisición, renovación)
}

export class PixelAddToCartDataModel implements IPixelAddToCartDataModel
{
  public value: number;
  public currency: string;
  public content_name: string;
  public content_type: string;
  public contents: IPixelContentsDataModel[];

  constructor(value: number, currency: string, content_name: string, content_type: string, contents: IPixelContentsDataModel[])
  {
    this.value = value;
    this.currency = currency;
    this.content_name = content_name;
    this.content_type = content_type;
    this.contents = contents;
  }
}

export interface IPixelPurchaseDataModel
{
  value: number;
  currency: string;
  contents: IPixelContentsDataModel[];
  num_items: number;
}

export class PixelPurchaseDataModel implements IPixelPurchaseDataModel
{
  public value: number;
  public currency: string;
  public contents: IPixelContentsDataModel[];
  public num_items: number;

  constructor(value: number, currency: string, contents: IPixelContentsDataModel[], num_items: number)
  {
    this.value = value;
    this.currency = currency;
    this.contents = contents;
    this.num_items = num_items;
  }
}

export interface IPixelInitiateCheckoutDataMoel
{
  value: number;
  currency: string;
  num_items: number;
  contents: IPixelContentsDataModel[];
}

export class PixelInitiateCheckoutDataModel implements IPixelInitiateCheckoutDataMoel
{
  public value: number;
  public currency: string;
  public num_items: number;
  public contents: IPixelContentsDataModel[];

  constructor(value: number, currency: string, num_items: number, contents: IPixelContentsDataModel[])
  {
    this.value = value;
    this.currency = currency;
    this.num_items = num_items;
    this.contents = contents;
  }
}
